import React from 'react';
import { Col, Container, Row,Button, ButtonToolbar,} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/stockMovementToGood';

/*import Table from '../../Tables/DataTable/components/DataTable';*/
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const stockMovementToGood = ({ t }) => (
  <Container>
    <Row>
      <Col md={10}>
        <h3 className="page-title">Stock Movement</h3>
      </Col>
	 
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

    
  </Container>
);

stockMovementToGood.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(stockMovementToGood);
